export const PAGE_SIZE_OPTIONS = [10, 25, 35, 50];
export const DEFAULT_PAGE_SIZE = 25;

export function isPriceNotDecided(vehicle) {
  return Boolean(vehicle?.price_not_decided);
}

export function formatVehiclePrice(vehicle) {
  if (!vehicle || isPriceNotDecided(vehicle)) return null;
  const n = Number(vehicle.price);
  if (!Number.isFinite(n) || n <= 0) return null;
  return `$${n.toLocaleString()}`;
}
